<ng-container *ngIf="progress !== 100">
    <div class="message-wrapper">
        <div class="progress-message">{{message}}</div>
        <!-- <div class="zcoin"></div> -->
    </div>
    <div class="progress-track">
        <div class="progress-bar" [ngStyle]="{'transform': 'scaleX(' + progressScale + ')'}"></div>
    </div>
</ng-container>